import classNames from 'classnames';

import './button.scss';
import Icon, { IconType } from '../icon/Icon';
import Tooltip, { TooltipProps } from '../tooltip/tooltip';

export enum ButtonType {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  TERTIARY = 'tertiary',
  DESTRUCTIVE = 'destructive',
}
export enum ButtonState {
  DEFAULT = 'default',
  HOVERED = 'hovered',
  ACTIVE = 'active',
  FOCUSED = 'focused',
  DISABLED = 'disabled',
}

export interface ButtonProps {
  label?: string;
  isLoading?: boolean;
  type?: ButtonType;
  state?: ButtonState;
  isSmall?: boolean;
  icon?: IconType;
  iconPosition?: 'left' | 'right';
  tooltip?: TooltipProps;
  extraClasses?: string;
  description?: string;
  onClick?: (e) => void;
}

const Button = ({
  label,
  isLoading = false,
  type = ButtonType.PRIMARY,
  state = ButtonState.DEFAULT,
  isSmall = false,
  icon,
  iconPosition = 'left',
  tooltip,
  extraClasses = '',
  description,
  onClick,
}: ButtonProps) => {
  const buttonClass = classNames('a-btn', {
    ['is-loading']: isLoading,
    [`a-btn--${type}`]: type,
    hover: state === ButtonState.HOVERED,
    active: state === ButtonState.ACTIVE,
    focus: state === ButtonState.FOCUSED,
    disabled: state === ButtonState.DISABLED,
    ['a-btn--small']: isSmall,
    [extraClasses]: extraClasses,
    'a-btn--icon': icon && !label,
  });

  const buttonElement = (
    <button
      className={buttonClass}
      type="button"
      onClick={onClick}
      disabled={state === ButtonState.DISABLED}
      aria-label={description}
    >
      {icon && iconPosition === 'left' && (
        <Icon iconType={icon} className="a-btn__icon" />
      )}
      {label && <span className="a-btn__label">{label}</span>}
      {icon && iconPosition === 'right' && (
        <Icon iconType={icon} className="a-btn__icon" />
      )}
    </button>
  );

  return tooltip ? (
    <Tooltip {...tooltip}>{buttonElement}</Tooltip>
  ) : (
    buttonElement
  );
};

export default Button;
